export class ProviderSettings {
    providerID: number;
    key: string;
    section: string;
    value: string;
}
